import React from 'react';
import PropTypes from 'prop-types';

class MembersIntro extends React.PureComponent {
    static propTypes = {
        content: PropTypes.string,
    };

    render() {
        const { content } = this.props;
        
        return <div dangerouslySetInnerHTML={{ __html: content }} />;
    }
}

export default MembersIntro;
